/** @typedef {{ image?: string, grad?: string, title: string, subtitle: string, h?: number }} AlbumPhoto */

/** @typedef {{ id: string, title: string, subtitle: string, count: number, cover: AlbumPhoto, photos: AlbumPhoto[] }} Album */

const g = {
  mono1: "linear-gradient(155deg,#15140f 0%,#3a382f 52%,#7c7766 100%)",
  mono2: "linear-gradient(160deg,#1d1c18 0%,#4a463d 55%,#9a9385 100%)",
  coast1: "linear-gradient(160deg,#1d2e36 0%,#3f5662 52%,#8aa0a2 100%)",
  coast2: "linear-gradient(155deg,#16242b 0%,#345059 55%,#7796a0 100%)",
  sav1: "linear-gradient(155deg,#241c10 0%,#5a4628 52%,#9a7c44 100%)",
  warm1: "linear-gradient(150deg,#3a2410 0%,#7a4f22 52%,#c89a52 100%)",
};

/** @param {string} grad @param {string} title @param {string} subtitle @param {number} [h] @returns {AlbumPhoto} */
function placeholder(grad, title, subtitle, h = 280) {
  return { grad, title, subtitle, h };
}

/** @type {Album[]} */
export const ALBUMS = [
  {
    id: "atlantic-wedding",
    title: "Atlantic Wedding",
    subtitle: "An intimate ceremony on the Portuguese coast.",
    count: 6,
    cover: {
      image: "cjmeister-com-_CJ08407.jpg",
      title: "Atlantic Wedding",
      subtitle: "Cascais, Portugal",
    },
    photos: [
      {
        image: "cjmeister-com-_CJ08407.jpg",
        title: "Arrival",
        subtitle: "Guests gather above the cliffs",
      },
      {
        image: "cjmeister-com-06076.jpg",
        title: "Quiet Moment",
        subtitle: "Before the vows",
      },
      placeholder(g.coast1, "Processional", "Walking to the altar", 300),
      placeholder(g.coast2, "Exchange", "The vows", 360),
      placeholder(g.warm1, "First Light", "Couple portrait at dusk", 260),
      placeholder(g.coast1, "Reception", "Tables by the sea", 320),
    ],
  },
  {
    id: "lewis-family",
    title: "The Lewis Family",
    subtitle: "A morning session at home with three generations.",
    count: 5,
    cover: {
      image: "cjmeister-com-06076.jpg",
      title: "The Lewis Family",
      subtitle: "Oxfordshire, UK",
    },
    photos: [
      {
        image: "cjmeister-com-06076.jpg",
        title: "Kitchen Light",
        subtitle: "Sunday breakfast",
      },
      placeholder(g.mono1, "Garden Steps", "Three generations", 300),
      placeholder(g.mono2, "Portrait", "The youngest", 340),
      placeholder(g.mono1, "Hands", "Grandmother and granddaughter", 260),
      placeholder(g.mono2, "Walk", "Leaving the house", 300),
    ],
  },
  {
    id: "serra-retreat",
    title: "Serra Retreat",
    subtitle: "A long weekend in the mountains — friends, fire, and fog.",
    count: 6,
    cover: {
      image: "cjmeister-com-_DSC4977-Edit-Edit.jpg",
      title: "Serra Retreat",
      subtitle: "Serra da Estrela, Portugal",
    },
    photos: [
      {
        image: "cjmeister-com-_DSC4977-Edit-Edit.jpg",
        title: "Forest Enduro",
        subtitle: "Cold morning ride through the pines",
      },
      placeholder(g.sav1, "Campfire", "After dark", 280),
      placeholder(g.mono2, "Mist", "Dawn on the ridge", 320),
      placeholder(g.sav1, "Trail", "The climb out", 260),
      placeholder(g.mono1, "Shelter", "Stone bothy", 300),
      placeholder(g.sav1, "Departure", "Loading the bikes", 340),
    ],
  },
];

/** @param {string} id */
export function getAlbumById(id) {
  return ALBUMS.find((album) => album.id === id);
}
